import { useState, useEffect } from "react";
import axios from "axios";
import css from "../index.module.css";
import Order from "@components/order";
import * as Types from "../../../types";

export default function Orders() {
  const [orders, setOrders] = useState<Types.Order[]>([]);

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_URL}/user/orders`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setOrders(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div className={css.col1}>
        <div className={css.orders}>
            {orders.map((item) => (
                <Order
                    id={item.id}
                    miniId={item.shortID}
                    createdAt={item.createdAt}
                    status={item.status}
                    totalPrice={item.totalPrice}
                    products={item.products}
                />
            ))}

            {orders.length <= 0 && (
                <a style={{ fontSize: 18 }}>заказов нет...</a>
            )}
        </div>
    </div>
  );
}
